/**
 * An object's `about` as the pages show it. The backend owns the words; this
 * only decides how much of them fits quietly under a heading.
 */

/** About two lines at the 70ch the pages set it in. */
const TWO_LINES = 140;

/** A sentence ends at . ! or ? (and a closing quote or bracket) before a capital letter or opening quote. */
const FIRST_SENTENCE = /^[\s\S]+?[.!?]["')]?(?=\s+["'(A-Z])/;

export interface AboutText {
  /** What shows at first: the whole text, or its first sentence when the whole runs past about two lines. */
  lead: string;
  /** True when `lead` is only the first sentence and the rest sits behind a disclosure. */
  isTruncated: boolean;
}

/** Null where the object declares no `about` (or only blanks), so a page draws nothing. */
export function aboutTextOf(
  about: string | undefined | null,
): AboutText | null {
  const text = about?.trim();
  if (!text) return null;
  if (text.length <= TWO_LINES) return { lead: text, isTruncated: false };
  const first = FIRST_SENTENCE.exec(text)?.[0];
  return first && first.length < text.length
    ? { lead: first, isTruncated: true }
    : { lead: text, isTruncated: false };
}
